// Only repeated cards share row heights. Mixed editorial columns keep their flow.
export const cardRowCount = (columns) => {
  const rows = columns.map(([, column]) => {
    const ids = column.blocks_layout?.items || [];
    return ids.length &&
      ids.every((id) => column.blocks?.[id]?.['@type'] === 'teaser')
      ? ids.length
      : 0;
  });
  return rows.length > 1 && rows.every(Boolean) ? Math.max(...rows) : 0;
};
